import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../../environments/environment';
import { RequestTokenService } from '../../../../../../services/request-token.service';

const API_URL = `${environment.apiUrl}v1/PresencaEscritorio`;

@Injectable({
  providedIn: 'root'
})
export class PresencaEscritorioApiService {

  constructor(
    private http: HttpClient,
    private requestToken: RequestTokenService
  ) { }

  private opcoes() {
    return {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };
  }

  public GetPresenca(ano: number, mes: number): Observable<any> {
    return this.http.get<any>(`${API_URL}/GetPresenca?ano=${ano}&mes=${mes}`, this.opcoes())
      .pipe(catchError(erro => throwError(erro)));
  }

  public RegistrarLocalizacao(latitude: number, longitude: number, precisaoMetros: number | null): Observable<any> {
    return this.http.post<any>(`${API_URL}/RegistrarLocalizacao`, {
      Latitude: latitude,
      Longitude: longitude,
      PrecisaoMetros: precisaoMetros
    }, this.opcoes()).pipe(catchError(erro => throwError(erro)));
  }
}
